import { memo, useEffect } from 'react';

import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';

import { useStore } from 'mobx/helpers';

const EXTERNAL_LOGIN_BACK_PATH_KEY = 'externalLoginBackPath';

const LogoutListener = observer(() => {
  const store = useStore();
  const history = useHistory();

  const clearStore = () => {
    try {
      sessionStorage.removeItem('searchText');
      sessionStorage.removeItem('tableSelectedTab');
      sessionStorage.removeItem('activeFilters');
      sessionStorage.removeItem('activeTimeFrames');
      sessionStorage.removeItem('tags');
      sessionStorage.removeItem('columns');
      sessionStorage.removeItem('apartmentFilters');
      sessionStorage.removeItem('loggedUserRole');
      store.logOut();
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (store.redirectionToSsoNeeded) {
      const currentUrl = window.location.href;
      const currentPath = window.location.pathname;
      clearStore();
      if (currentPath.includes('/scheda-cliente/') || currentPath.includes('/scheda-appartamento/')) {
        sessionStorage.setItem(EXTERNAL_LOGIN_BACK_PATH_KEY, currentPath);
      }
      history.push(`/login?backTo=${encodeURIComponent(currentUrl)}`);
    }
  }, [store.redirectionToSsoNeeded]);

  return null;
});

export default memo(LogoutListener);
